module.exports = __webpack_public_path__ + "img/certificate.9b838bf5.png";